import './Map.css';
import '@fontsource/inter';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import Back from '../components/Back';
import React, { useState } from 'react';

function CampusMap() {
    const [openDropdown, setOpenDropdown] = useState(null); // Tracks which dropdown is open

    // Toggle function for dropdowns
    const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
    };

    return (
        <section className="container">
            <CurrentTime />
            <DynamicIsland />
            <Back />

            {/* Campus Map */}
            <div className="map-container">
                <div className="iframe-wrapper">
                    <iframe
                        src="https://www.towson.edu/maps/"
                        title="Campus map"
                        className="campus-map"
                        scrolling="no"
                    ></iframe>
                </div>
            </div>

            <div className="campus-accommodations">
                <h2>Campus Accommodations</h2>

                <div className="dropdown">
                    <button
                        onClick={() => toggleDropdown("lactation")}
                        className="dropdown-button"
                    >
                        Lactation Room Locations
                    </button>
                    <div
                        className={`dropdown-content ${
                            openDropdown === "lactation" ? "dropdown-open" : "dropdown-closed"
                        }`}
                    >
                        <p>TU Lactation Rooms provide a private, secure, clean space for chestfeeding and breastfeeding. They are available to all students, faculty, staff, spouses and domestic partners at the following campus locations:</p>
                        <ul>
                            <li>7400 York Road, Room 2103</li>
                            <li>Administration Building, Room 115B 
                                (obtain the key from AD114)</li>
                            <li>Burdick Hall, Room 127</li>
                            <li>College of Liberal Arts, Room 2231</li>
                            <li>Cook Library, Room 527</li>
                            <li>Health Professions, Room 4213</li>
                            <li>Psychology, Room 506</li>
                            <li>Science Complex, Room 2155</li>
                            <li>University Union, Room 253</li>
                            <li>Van Bokkelen Hall, Room 009</li>
                            <li>West Village Commons, Room 320</li>
                        </ul>
                    </div>
                    <button
                        onClick={() => toggleDropdown("meditation")}
                        className="dropdown-button"
                    >
                        Interfaith Meditation Rooms
                    </button>
                    <div
                        className={`dropdown-content ${
                            openDropdown === "meditation" ? "dropdown-open" : "dropdown-closed"
                        }`}
                    >
                        <p>
                            Interfaith meditation rooms are part of several ongoing initiatives to
                            accommodate and support students, faculty, and staff in reflection and
                            meditation while on campus.
                        </p>
                        <p>Room locations on campus can be found:</p>
                        <ul>
                            <li>Cook Library, Room 401</li>
                            <li>Enrollment Services, Room 117</li>
                            <li>Health Professions, Room 3211</li>
                            <li>University Union, Room 335B</li>
                        </ul>
                        <p>
                            <a
                                href="https://www.towson.edu/studentdiversity/development-diversity-programs/religious-spiritual-life.html"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Learn more about Interfaith Meditation Rooms.
                            </a>
                        </p>
                    </div>
                    <button
                        onClick={() => toggleDropdown("all-gender-restroom")}
                        className="dropdown-button"
                    >
                        All Gender Restrooms
                    </button>
                    <div
                        className={`dropdown-content ${
                            openDropdown === "all-gender-restroom" ? "dropdown-open" : "dropdown-closed"
                        }`}
                    >
                            <p>* Some bathrooms have limited access due to being located in offices or residence halls.</p>
                            <h3>Academic Precinct (Main Campus)</h3>
                            <h4>7800 York Road within Honors College*</h4>
                                <li>YR 134D*</li>
                                <li>YR 134E*</li>
                            <h4>Burdick Hall</h4>
                                <li>Room 104</li>
                                <li>Room 105</li>
                                <li>Room 143 (Restroom/Shower)</li>
                                <li>Room 168 (Restroom/Shower)</li>
                            <h4>Center for the Arts</h4>
                            <li>Room 2074</li>
                            <li>Room 3043</li>
                            <li>Room 3042</li>
                            <li>Room 3032</li>
                            <h4>College of Liberal Arts</h4>
                            <li>Room 3231</li>
                            <li>Room 4231</li>
                            <h4>Cook Library</h4>
                            <li>Room 303</li>
                            <li>Room 304</li>
                            <h4>Ward and West</h4>
                            <li>Restroom Room 0101</li>
                            <li>Restroom Room 0103</li>
                            <li>Room 1201</li>
                            <li>Room 1203</li>
                            <li>Room 2201</li>
                            <li>Room 2203</li>
                            <h4>General Services</h4>
                            <li>Room 123A (Restroom/Shower)</li>
                            <h4>Glen Dining</h4>
                            <li>Room 304</li>
                            <h4>Glen Tower A</h4>
                            <li>Room 115A</li>
                            <li>Room 115B</li>
                            <li>Room 254</li>
                            <li>Room 255</li>
                            <h4>Glen Tower B</h4>
                            <li>Room 114A</li>
                            <li>Room 114B</li>
                            <li>Room 14</li>
                            <li>Room 16</li>
                            <h4>Glen Tower C</h4>
                            <li>Room 114A</li>
                            <li>ROom 114B</li>
                            <h4>Glen Tower D</h4>
                            <li>Room 114A</li>
                            <h4>Media Center</h4>
                            <li>Room 112A</li>
                            <li>Room 112B</li>
                            <h4>Newell Dining</h4>
                            <li>Room 202</li>
                            <li>Room 203</li>
                            <li>Room 227</li>
                            <li>Room 228</li>
                            <h4>Newell Hall</h4>
                            <li>Restroom Lobby D</li>
                            <li>Restroom Lobby E</li>
                            <h4>Power Plant</h4>
                            <li>Room 108C</li>
                            <li>Room 310B</li>
                            <h4>Prettyman Hall*</h4>
                            <li>Room 128*</li>
                            <li>Room 129*</li>
                            <h4>Psychology</h4>
                            <li>Room 199</li>
                            <h4>Residence Tower</h4>
                            <li>Room 0001D</li>
                            <li>Room 101A</li>
                            <li>Room 101B</li>
                            <h4>Richmond Hall</h4>
                            <li>Restroom 2C1A</li>
                            <li>Restroom 2C1B</li>
                            <h4>Scarborough Hall*</h4>
                            <li>Room 106*</li>
                            <li>Room 107*</li>
                            <h4>Science Complex</h4>
                            <li>Room 2208</li>
                            <h4>Transportation Annex</h4>
                            <li>Room TX 104 (Public Restroom)</li>
                            <li>Room TX 105 (Public Restroom)</li>
                            <h4>University Union</h4>
                            <li>Room 331</li>
                            <h4>Van Bokkelen Hall</h4>
                            <li>Room 020</li>
                            <li>Room 021</li>
                            <h3>West Village Precinct (Main Campus)</h3>
                            <h4>Caroll Hall</h4>
                            <li>Room 106</li>
                            <li>Room 107</li>
                            <h4>Clara Barton House</h4>
                            <li>Room 123</li>
                            <li>Room 124</li>
                            <h4>Frederick Douglass House</h4>
                            <li>Room 120</li>
                            <li>Room 119</li>
                            <h4>Marshall House</h4>
                            <li>Room 112</li>
                            <li>Room 114</li>
                            <li>Room 051</li>
                            <li>Room 052</li>
                            <h4>West Village Commons</h4>
                            <li>Room 319</li>
                            <li>Room 412</li>
                            <li>Room 121</li>
                            <h3>Athletic Precinct (Main Campus)</h3>
                            <h4>Auburn House</h4>
                            <li>Room 108</li>
                            <h4>TU Arena</h4>
                            <li>Near Room 211</li>
                            <h4>South Campus Pavilion</h4>
                            <li>Restroom 0100A</li>
                            <li>Restroom 0100B</li>
                            <li>Restroom 0100C (Accessible)</li>
                            <li>Restroom 0100D (Accessible)</li>
                            <h4>Towson Center</h4>
                            <li>Room 345</li>
                            <h4>Towson Softball Stadium</h4>
                            <li>Room SB103 (Family Restroom)</li>
                            <h3>Satellite Locations</h3>
                            <h4>401 washington Avenue</h4>
                            <li>Room 196</li>
                            <li>Room 313A</li>
                            <li>Room 899</li>
                            <li>Room 1043</li>
                            <li>Room 1199</li>
                            <h4>7400 York Road</h4>
                            <li>Room 327</li>
                            <li>Room 436</li>
                            <h4>Armory</h4>
                            <li>Room 1217</li>
                            <li>Room 1219</li>
                            <li>Room 2103</li>
                            <li>Room 2104</li>
                            <h4>Towson Run Apartments</h4>
                            <li>Room 128</li>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default CampusMap;
